import Logo from "assets/images/Logo.png";

const domain = process.env.REACT_APP_API_URL || "https://api.azucarai.com";

// const domain = "http://localhost:8000";
const logo = Logo;

const globalVariable = {
  domain,
  logo,
};
export default globalVariable;
